import { ReactNode, useEffect, useState } from 'react';
import { useResizeDetector } from 'react-resize-detector';

import { layoutItemClassName } from './styles';

export interface Props {
  children?: ReactNode;
}

const CardPostsLayoutItem = ({ children }: Props) => {
  const [dimensions, setDimensions] = useState({ height: 0 });
  const { height, ref } = useResizeDetector();

  useEffect(() => {
    if (ref.current) {
      setDimensions({
        height: ref.current.offsetHeight,
      });
    }
  }, [height, ref]);

  return (
    <div
      className={layoutItemClassName}
      style={{ gridRowEnd: `span ${Math.ceil((dimensions.height + 16) / 20)}` }}
    >
      <div ref={ref}>{children}</div>
    </div>
  );
};

CardPostsLayoutItem.displayName = 'CardPostsLayoutItem';

export default CardPostsLayoutItem;
